import styled from 'styled-components';
import { darkgrey, white } from 'styles/Colors';
import { OptionText } from '../../FieldingSequenceFlow/components/SequenceBottomBar/components/BottomBarOptionStyles';

export const EndSequenceBottomBar = styled.div`
  margin-top: 6px;
  display: flex;
  justify-content: center;
  font-weight: 700;
  width: 100%;

  .exit-sequence,
  .finish-process {
    background-color: ${white};
    display: flex;
    justify-content: center;
    flex-direction: column;
    width: 100%;
    height: 100%;
    padding: 8px;
    box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.14);
    border-radius: 5px;

    &:hover {
      cursor: pointer;
    }

    ${OptionText} {
      color: ${darkgrey};
      font-size: 11px;
      margin-bottom: 6px;
    }
  }

  .finish-process {
    margin-left: 8px;
  }
`;
